export default __webpack_public_path__ + "static/media/loader.d5751820.gif";